import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionSummary, Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useGetDisbursementAccountsQuery } from '../../../../api/disbursements/disbursementApi'
import type { AssetHolderUpdateDto } from '../../../../api/schema-dtos/AssetHolderCrudDtos'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import ErrorComponent from '../../../shared/components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../shared/components/ui-widgets/LoadingComponent'
import type { AssetHolderIdProps } from '../../pages/DashboardHome'
import AccountsComponent from './AccountsComponent'

interface ComponentProps extends AssetHolderIdProps {
  assetHolder: AssetHolderUpdateDto
  maxCardWidth: number
}

const AccordionCashOutAccounts: React.FC<ComponentProps> = ({ assetHolderId, assetHolder, maxCardWidth }: ComponentProps) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  const getDisbursementAccountsApiResult = useGetDisbursementAccountsQuery(assetHolderId)

  const accordionIdentifier = `dashboard-exchange-instructions-${assetHolderId}`

  return (
    <>
      <Accordion sx={{ px: 4, pt: 2 }} expanded={expanded} onChange={(evt, expanded) => { setExpanded(expanded) }} >

        <AccordionSummary expandIcon={<ExpandMoreIcon color={'primary'}/>}
                          aria-controls={accordionIdentifier}
                          id={accordionIdentifier} sx={{ px: 0, pb: 2 }}>
          {/* <Typography variant={'body1'}>Donate all your balances to a selected charity</Typography> */}
          <Typography variant={'h3'} sx={{ mb: 1 }}>Cash Out Accounts</Typography>
        </AccordionSummary>

        <Box sx={{ pb: 4 }}>
          {(getDisbursementAccountsApiResult.isLoading) && <LoadingComponent/>}
          {getDisbursementAccountsApiResult.isError &&
            <ErrorComponent message={RtkQueryHelper.mapResponseError(getDisbursementAccountsApiResult.error)}/>}

          {getDisbursementAccountsApiResult.isSuccess &&
            <AccountsComponent
              assetHolderId={assetHolderId}
              disbursementAccounts={getDisbursementAccountsApiResult.data}
              hasPassedKyc={assetHolder.hasPassedKyc}
              maxCardWidth={maxCardWidth}
              multiAccountView={true}
            />
          }
        </Box>

      </Accordion>
    </>
  )
}

export default AccordionCashOutAccounts
